import * as React from "react";
import type { SVGProps } from "react";
const SvgIconTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.63 2.4c-1 .04-1.98.47-2.7 1.2-.44.46-.73.93-.93 1.53-.12.34-.17.56-.2.94l-.03.29H3.1l-1.66.01-.14.07q-.3.15-.44.43C.82 7 .8 7.05.8 7.23s.01.22.07.34q.2.4.63.5l.71.02h.57v5.73l.02 5.73.05.2c.2.72.66 1.3 1.31 1.61.3.15.52.2.87.24s7.22.03 7.57 0c1.06-.1 1.88-.8 2.17-1.82.08-.3.09-.57.09-6.16V8.1h.65c.72-.02.76-.02.98-.18.12-.1.26-.28.3-.43.05-.12.04-.41 0-.54-.05-.14-.2-.33-.32-.42-.22-.15-.15-.15-1.95-.15-1.25 0-1.65-.02-1.66-.04l-.02-.17q0-.28-.11-.72c-.36-1.44-1.5-2.57-2.94-2.93-.35-.09-.8-.13-1.16-.12M8.4 4.13q-.7.13-1.22.63c-.39.38-.64.9-.68 1.4l-.01.2h4.64l-.01-.17q-.04-.4-.25-.81-.34-.7-1.03-1.03c-.14-.07-.35-.16-.47-.19-.25-.06-.72-.08-.97-.03M4.49 13.7c0 5.45.01 5.61.06 5.73.06.17.25.35.42.42l.14.05h3.7c3.7 0 3.72 0 3.85-.05.18-.07.35-.24.42-.42l.05-.13V8.09H4.49zm12.46-3.32c-.53.13-.8.77-.52 1.25.09.15.28.31.44.38l.13.05h5.52l.14-.05q.3-.13.46-.44c.07-.14.08-.18.07-.36s0-.23-.06-.35q-.15-.29-.44-.44l-.14-.06H19.8c-2.15-.01-2.76 0-2.86.02m-.08 3.21q-.27.12-.4.32c-.3.44-.13 1.03.35 1.26l.14.06h4.03l.11-.05c.15-.07.35-.26.42-.4.11-.23.11-.55 0-.78-.07-.14-.27-.33-.42-.4-.11-.05-.11-.05-2.1-.06h-2zm.18 3.14c-.34.05-.62.3-.7.63-.05.16-.03.41.05.57.1.23.34.43.59.48.17.03 2.19.03 2.36 0l.21-.07c.13-.07.31-.26.38-.41.05-.11.06-.17.06-.36 0-.2 0-.25-.06-.36-.08-.15-.25-.33-.4-.4-.05-.03-.17-.07-.26-.08-.19-.03-2.05-.03-2.23 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconTrash;
